import './payment-account.scss';
import {useNavigate} from "react-router-dom";
import {useQueryUser} from "../../../../../api/admin/useQueryAdmin";
import Loading from "../../../../../components/UI/Loading/Loading";
import LabelKMQ from "../../../../../components/UI/Label/LabelKMQ";
import EditIcon from '../../../../../assets/icons/UI/icons/edit.svg'
import React, {useEffect, useState} from "react";
import InputKMQ from "../../../../../components/UI/Input/InputKMQ";
import {INewUser} from "../../../../../constants/types/INewUser";
import ButtonKMQ from "../../../../../components/UI/Button/ButtonKMQ";
import {ButtonTypes} from "../../../../../constants/ui/types/ButtonTypes";
import {useMutateEditUser} from "../../../../../api/cpl-applicant/useMutateUser";
import {object, string, ValidationError} from "yup";


const PaymentAccount = () => {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [newUser, setNewUser] = useState<INewUser>({});
  const [inputError, setInputError] = useState<boolean>(false);
  const {data, isLoading, refetch} = useQueryUser();
  const {mutate, isSuccess, error} = useMutateEditUser();
  const [emailValidationErrorStr, setEmailValidationErrorStr] = useState<string>("");

  const handleChangePassword = () => {
    navigate(`/login/reset-password`);
  }

  const cancelEdit = () => {
    setIsEdit(false);
    setNewUser(data);
    setEmailValidationErrorStr('');
  }

  const editUserSchema = object({
    email: string().min(3).required(),
    first_name: string().min(1).required(),
    last_name: string().min(1).required(),
    date_of_birth: string().length(10).required(),
  });

  const editUser = async () => {
    try {
      await editUserSchema.validate(newUser);
      mutate(newUser);
      localStorage.removeItem('basic_info');
      // @ts-ignore
    } catch (e: ValidationError) {
      console.log('e', e.errors)
      setInputError(true);
    }
  }

  useEffect(() => {
    if (data) {
      setNewUser(data)
    }
  }, [data])

  useEffect(() => {
    if (isSuccess) {
      setIsEdit(false);
      refetch();
    }
  }, [isSuccess])

  useEffect(() => {
    if (inputError && !newUser.email) {
      setEmailValidationErrorStr('Please enter your email');
    }
    //@ts-ignore
    else if (error?.response?.status === 409) {
      setEmailValidationErrorStr('This email has already been registered')
    }
    //@ts-ignore
    else if (inputError && error?.response?.data?.error?.includes("email")) {
      setEmailValidationErrorStr('Please enter a valid email')
    }
    else {
      setEmailValidationErrorStr('')
    }
  }, [error, inputError, newUser])

  return <div className={'payment-account'}>
    <Loading loading={isLoading}/>

    {!isEdit
      ? <div className={'payment-account-edit'} onClick={() => setIsEdit(true)}>
        <img
          src={EditIcon}
          alt={'edit'}
          className={'payment-account-edit-icon'}
        />
        <span className={'payment-account-edit-text'}>
        Edit
      </span>
      </div>
      : null
    }

    <div className={'payment-account-item'}>
      <LabelKMQ>First name</LabelKMQ>
      {
        isEdit
          ? <InputKMQ
            value={newUser.first_name ?? ''}
            onChange={(e) => setNewUser({...newUser, first_name: e.target.value})}
            type={'text'}
            placeholder={'Enter first name'}
            error={
              (inputError && !newUser.first_name)
                ? 'Please enter your first name'
                : ''
            }
          />
          : <div className={'payment-account-item-data'}>
            {data?.first_name}
          </div>
      }
    </div>
    <div className={'payment-account-item'}>
      <LabelKMQ>Last name</LabelKMQ>
      {
        isEdit
          ? <InputKMQ
            value={newUser.last_name ?? ''}
            onChange={(e) => setNewUser({...newUser, last_name: e.target.value})}
            type={'text'}
            placeholder={'Enter last name'}
            error={
              (inputError && !newUser.last_name)
                ? 'Please enter your last name'
                : ''
            }
          />
          : <div className={'payment-account-item-data'}>
            {data?.last_name}
          </div>
      }
    </div>
    <div className={'payment-account-item'}>
      <LabelKMQ>Date of birth</LabelKMQ>
      {isEdit
        ? <InputKMQ
          value={newUser.date_of_birth ?? ''}
          onChange={(e) => {
            if (e.target.value.length === 10) {
              setNewUser({...newUser, date_of_birth: e.target.value}) ;
            }
          }}
          type={'date'}
          placeholder={'Enter date of birth'}
          error={
            (inputError && !newUser.date_of_birth)
              ? 'Please enter your date of birth'
              : ''
          }
        />
        : <div className={'payment-account-item-data'}>
          {data?.date_of_birth}
        </div>
      }
    </div>
    <div className={'payment-account-item'}>
      <LabelKMQ>Email</LabelKMQ>
      {isEdit
        ? <InputKMQ
          value={newUser.email ?? ''}
          onChange={(e) => setNewUser({...newUser, email: e.target.value})}
          type={'text'}
          placeholder={'Enter email'}
          error={emailValidationErrorStr}
        />
        : <div className={'payment-account-item-data'}>
          {data?.email}
        </div>
      }
    </div>
    <div className={'payment-account-item'}>
      <LabelKMQ>Password</LabelKMQ>
      <div className={'payment-account-item-data'}>
        ************
        {
          isEdit
            ? <span className={'payment-account-item-data-password'} onClick={handleChangePassword}>
              Change password
            </span>
            : null
        }
      </div>
    </div>

    {isEdit
      ? <div className={'payment-account-footer'}>
        <ButtonKMQ onClick={cancelEdit}>
          Cancel
        </ButtonKMQ>
        <ButtonKMQ onClick={editUser} type={ButtonTypes.Tertiary}>
          Save
        </ButtonKMQ>
      </div>
      : null
    }
  </div>
}

export default PaymentAccount;